// extracted by mini-css-extract-plugin
module.exports =  {"InfoBox":"BRMxaUhrIqPP067rE7FG"};